import { useQuery } from 'react-query';

import { getLatestProgramDate as queryFn } from 'api/endPoints/getLatestProgramDate';
import { QueryKeys } from 'api/queryKeys';

export const useQueryLatestDateOfProgram = (metaDataId: number) => {
    return useQuery<number, QueryError, number, [QueryKeys, unknown]>({
        queryKey: ['latestDateOfProgram', metaDataId],
        queryFn: () => queryFn(metaDataId),
        enabled: metaDataId !== undefined,
    });
};
